import { useState } from 'react';
import { MainAdminLayout } from 'admin/layout/MainAdminLayout';
import { Images } from 'assets/images';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { ProfileConfirmModal } from 'admin/components/ProfileModals/profileConfirmModal';
import { ProfileLogOutModal } from 'admin/components/ProfileModals/profileLogOutModal';
import { ProfileDeleteModal } from 'admin/components/ProfileModals/profileDeleteModal';
import { ModalContainer } from 'admin/containers/Home/styled';
import { PROFILE_MODAL_CONSTANTS } from 'admin/utils/contants';
import {
  SampleDiv,
  AdminProfileWrapper,
  AdminProfileSection,
  PasswordWrapper,
  InfoAboutSection,
  SectionTitle,
  SectionDescription,
  FullSectionTitle,
  SectionInput,
  SectionButton,
  SectionButtonWrapper,
  AdminProfileAuth,
  AboutAuthentication,
  AuthenticationDescription,
  EnableButton,
  AdminProfileSessionsAndDelete,
  BrowserSession,
  DeleteAccount,
  BrowserSessionsSection,
  BrowserSessionTitle,
  BrowserSessionDescription,
  DesktopSigns,
  DesktopSign,
  DesktopImage,
  OperationName,
  OperationNameAndIP,
  OperationDevice,
  LogOutOtherBrowsers,
  DeleteAccountButton,
  DeleteAccountSection,
  DeleteAccountDescription,
  PasswordsLine,
} from 'admin/containers/Profile/styled';

export const AdminProfile = () => {
  const [modalState, setModalState] = useState();
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const handleConfirmModal = (modalConstant) => {
    setModalState(modalConstant);
    setIsOpen((prev) => !prev);
  };

  return (
    <MainAdminLayout>
      {isOpen && modalState === PROFILE_MODAL_CONSTANTS.changePassword ? (
        <ModalContainer>
          <SampleDiv ref={ref}>
            <ProfileConfirmModal handleConfirmModal={handleConfirmModal} />
          </SampleDiv>
        </ModalContainer>
      ) : isOpen && modalState === PROFILE_MODAL_CONSTANTS.logOut ? (
        <ModalContainer>
          <SampleDiv ref={ref}>
            <ProfileLogOutModal handleConfirmModal={handleConfirmModal} />
          </SampleDiv>
        </ModalContainer>
      ) : isOpen && modalState === PROFILE_MODAL_CONSTANTS.deleteAccount ? (
        <ModalContainer>
          <SampleDiv ref={ref}>
            <ProfileDeleteModal handleConfirmModal={handleConfirmModal} />
          </SampleDiv>
        </ModalContainer>
      ) : null}
      <AdminProfileWrapper>
        <AdminProfileSection>
          <InfoAboutSection>
            <FullSectionTitle>Profile Information</FullSectionTitle>
            <SectionDescription>
              Update your account's profile information and email address.
            </SectionDescription>
          </InfoAboutSection>
          <PasswordWrapper>
            <InfoAboutSection>
              <SectionTitle>Name</SectionTitle>
              <SectionInput type="text" />
            </InfoAboutSection>

            <InfoAboutSection>
              <SectionTitle>Email</SectionTitle>
              <SectionInput type="text" />
            </InfoAboutSection>
          </PasswordWrapper>

          <SectionButtonWrapper>
            <SectionButton
              onClick={() =>
                handleConfirmModal(PROFILE_MODAL_CONSTANTS.changePassword)
              }
            >
              Save
            </SectionButton>
          </SectionButtonWrapper>
        </AdminProfileSection>

        <AdminProfileSection isUpdatePass>
          <InfoAboutSection isSectionDescription>
            <FullSectionTitle>Update Password</FullSectionTitle>
            <SectionDescription>
              Ensure your account is using a long, random password to stay secure.
            </SectionDescription>
          </InfoAboutSection>

          <PasswordWrapper isPassword>
            <InfoAboutSection>
              <SectionTitle>Current Password</SectionTitle>
              <SectionInput type="text" />
            </InfoAboutSection>

            <PasswordsLine>
              <InfoAboutSection>
                <SectionTitle>New Password</SectionTitle>
                <SectionInput type="text" />
              </InfoAboutSection>

              <InfoAboutSection isPassword>
                <SectionTitle>Confirm Password</SectionTitle>
                <SectionInput type="text" />
              </InfoAboutSection>
            </PasswordsLine>
          </PasswordWrapper>

          <SectionButtonWrapper buttonWrapper>
            <SectionButton>Save</SectionButton>
          </SectionButtonWrapper>
        </AdminProfileSection>

        <AdminProfileAuth>
          <InfoAboutSection>
            <FullSectionTitle>Two Factor Authentication</FullSectionTitle>
            <SectionDescription>
              Add additional security to your account using two factor
              authentication.
            </SectionDescription>
          </InfoAboutSection>

          <AboutAuthentication>
            <SectionDescription>
              You have not enabled two factor authentication.
            </SectionDescription>

            <AuthenticationDescription>
              When two factor authentication is enabled, you will be prompted for a
              secure, random token during authentication. You may retrieve this token
              from your phone's Google Authenticator application.
            </AuthenticationDescription>
          </AboutAuthentication>
          <EnableButton>
            <SectionButton>Save</SectionButton>
          </EnableButton>
        </AdminProfileAuth>

        <AdminProfileSessionsAndDelete>
          <BrowserSession>
            <BrowserSessionsSection>
              <BrowserSessionTitle>Browser Sessions</BrowserSessionTitle>
              <BrowserSessionDescription>
                Add additional security to your account using two factor
                authentication.
              </BrowserSessionDescription>
            </BrowserSessionsSection>

            <BrowserSessionsSection isLongText>
              <BrowserSessionDescription isLongText>
                If necessary, you may log out of all of your other browser sessions
                across all of your devices. Some of your recent sessions are listed
                below; however, this list may not be exhaustive. If you feel your
                account has been compromised, you should also update your password.
              </BrowserSessionDescription>
              <DesktopSigns>
                <DesktopSign>
                  <DesktopImage src={Images.monitorSilverIcon} />
                  <OperationNameAndIP>
                    <OperationName>Windows - Edge</OperationName>
                    <OperationName>
                      195.250.81.199,
                      <OperationDevice>This device</OperationDevice>
                    </OperationName>
                  </OperationNameAndIP>
                </DesktopSign>
                <DesktopSign isLastActive>
                  <DesktopImage src={Images.monitorSilverIcon} />
                  <OperationNameAndIP isLastActive>
                    <OperationName>OS X - Safari</OperationName>
                    <OperationName>
                      195.250.81.199, Last active 4 minutes ago
                    </OperationName>
                  </OperationNameAndIP>
                </DesktopSign>
              </DesktopSigns>
            </BrowserSessionsSection>
            <LogOutOtherBrowsers
              onClick={() => handleConfirmModal(PROFILE_MODAL_CONSTANTS.logOut)}
            >
              Log Out Other Browser Session
            </LogOutOtherBrowsers>
          </BrowserSession>

          <DeleteAccount>
            <BrowserSessionsSection>
              <BrowserSessionTitle>Delete Account</BrowserSessionTitle>
              <BrowserSessionDescription>
                Permanently delete your account.
              </BrowserSessionDescription>
            </BrowserSessionsSection>

            <DeleteAccountSection>
              <DeleteAccountDescription isLongText>
                Once your account is deleted, all of its resources and data will be
                permanently deleted. Before deleting your account, please download
                any data or information that you wish to retain.
              </DeleteAccountDescription>
            </DeleteAccountSection>

            <DeleteAccountButton
              onClick={() =>
                handleConfirmModal(PROFILE_MODAL_CONSTANTS.deleteAccount)
              }
            >
              Delete Account
            </DeleteAccountButton>
          </DeleteAccount>
        </AdminProfileSessionsAndDelete>
      </AdminProfileWrapper>
    </MainAdminLayout>
  );
};
